import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import SessionProp, { PARTICIPATION_STAT } from '../../propTypes/sessionProp';
import AcademySessionMap from '../../detail/AcademySessionMap';
import { checkIfHasCreatorAccess } from '../../propTypes/sessionUtils';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import QRCodeComponent from '../../../../commonComponents/widgets/QRCodeComponent';
import { SESSION_TYPE } from '../../../../services/utilityFunctions';

function MoreInfoClassroom(props) {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;

  /** PROPS */
  const { t, session, onQRModal } = props;

  const {
    confirmationLink = null,
    name,
    confirmationLinkTimeStatus,
    participationStatus,
    type,
  } = session || {};

  const openQRModal = () => {
    onQRModal(confirmationLink);
  };
  const handleConfirmationLink = confirmationLinkHref => {
    window.location.href = confirmationLinkHref;
  };

  const containerClass =
    'm-portlet m-portlet--rounded m-portlet--rounded-force' +
    ' m-portlet--full-height session-details-content-container session-content-more-info-container';

  const wrapperClass = `
    m-portlet
    m-portlet--rounded
    m-portlet--rounded-force
    m-portlet--full-height
    session-details-content-container
    confirmation-participant-classroom
  `;

  const qrCodeNameImg = `${name}_QR.png`;
  return (
    <>
      {checkIfHasCreatorAccess(session, loggedUserId) ? (
        <div className={containerClass}>
          <QRCodeComponent
            value={confirmationLink}
            title={t('access_session.detail.qrTitle')}
            buttonText={t('access_session.detail.qrButton')}
            onClick={openQRModal}
            hasButton
            hasDownload
            downloadImageName={qrCodeNameImg}
          />
        </div>
      ) : (
        <>
          {confirmationLinkTimeStatus &&
          participationStatus !== PARTICIPATION_STAT.PARTICIPATED &&
          type !== SESSION_TYPE.CLASSROOM ? (
            <div className={wrapperClass}>
              <div>
                <span className="confirmation-title">
                  {t('session.webinar.ongoing.confirm.participation')}
                </span>
                <div className="confirm-participation row">
                  <div className="col-12 col-lg-5 containers">
                    <QRCodeComponent
                      value={confirmationLink}
                      buttonText={t('access_session.detail.qrButton')}
                      onClick={() => {
                        onQRModal(confirmationLink);
                      }}
                      hasButton
                      size={99}
                      btnClass="qrWebinar-btn"
                    />
                  </div>
                  <div className="col-12 col-lg-1 containers">
                    <span className="span-or">{t('or')}</span>
                  </div>
                  <div className="col-12 col-lg-5 containers container-btn">
                    <button
                      type="button"
                      onClick={() => handleConfirmationLink(confirmationLink)}
                      className="btn btn-outline-dynamic confirmation-btn"
                    >
                      {t('session.webinar.ongoing.confirm')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="session-details-content-container">
              <AcademySessionMap t={t} session={session} />
            </div>
          )}
        </>
      )}
    </>
  );
}

MoreInfoClassroom.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
  onQRModal: PropTypes.func.isRequired,
};
MoreInfoClassroom.defaultPros = {};

export default translate(MoreInfoClassroom);
